"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layer = void 0;

var React = _interopRequireWildcard(require("react"));

var _Map = require("./Map");

var _Source = require("./Source");

var Layer = function Layer(_ref) {
  var layerId = _ref.layerId,
      type = _ref.type,
      sourceLayer = _ref.sourceLayer,
      _ref$paint = _ref.paint,
      paint = _ref$paint === void 0 ? {} : _ref$paint,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? {} : _ref$layout;
  var map = React.useContext(_Map.MapContext);
  var source = React.useContext(_Source.SourceContext);
  React.useEffect(function () {
    map === null || map === void 0 ? void 0 : map.on('styledata', function (e) {
      if (!(map === null || map === void 0 ? void 0 : map.getLayer(layerId)) && (map === null || map === void 0 ? void 0 : map.getSource(source))) {
        map === null || map === void 0 ? void 0 : map.addLayer({
          id: layerId,
          type: type,
          source: source,
          'source-layer': sourceLayer,
          paint: paint,
          layout: layout
        });
      }

      ;
    });
  }, [layerId, map, paint, source, sourceLayer, type, layout]);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

exports.Layer = Layer;